<template>
  <li>
    <button type="button" v-if="$user.isAdminOrCoordinator && routeIsJobs" @click="toggleJobPublic" class="public" :class="{ 'active': jobIsPublic }">
			<i class="fa fa-globe-asia"></i>
		</button>
    <router-link :to="{ name: 'jobs.show', params: { id: job.id } }">
      <div class="row">
        <div class="col-xs-12 col-lg-8">
          <p class="strong no-margin" v-if="job.user">{{ job.user.profile.company_name }}</p>
          <h2 class="truncate">
            <strong>{{ job.number }}</strong>

            <!-- Only show commodity and locations if we have enough details. -->
            <template v-if="jobHasEnoughDetails">
              - {{ job.commodity_and_location }}
            </template>
          </h2>
          <p>
            <ul class="details">
              <li><span>Start Date:</span> {{ job.start_at }}</li>
              <li><span>Order:</span> {{ job.order_reference }}</li>
              <li><span>Quantity:</span> {{ job.quantity }}</li>
              <li><span>Rate:</span> {{ job.rate }}</li>
            </ul>
          </p>
        </div>
        <div class="col-xs-8 col-lg-2">
          <div class="progress">
            <div
              :style="{ width: `${job.progress_completed_percentage}%` }"
              aria-valuemax="100"
              aria-valuemin="0"
              :aria-valuenow="job.progress_completed_percentage"
              role="progressbar"
              class="progress-bar" :class="`progress-bar-${job.status_class}`">
              <span class="sr-only">{{ job.progress_completed_percentage }}% Complete</span>
            </div>
          </div>
        </div>
        <div class="col-xs-4 col-lg-2">
          <span class="job-status" :class="`text-${job.status_class}`">{{ job.status_text }}</span>
        </div>
      </div>
    </router-link>
  </li>
</template>

<script>
  import { mapActions, mapMutations } from 'vuex'
  import { ADD_JOB } from 'vx/mutations'
  import { isObject } from 'lodash'
  import { notify } from 'utils'
  export default {
    props: ['job'],

    computed: {
      jobHasEnoughDetails () {
        return isObject(this.job.commodity) ||
          isObject(this.job.location_from) ||
          isObject(this.job.location_to)
      },

      jobIsPublic () {
        return this.job.public
      },

      routeIsJobs () {
        return this.$route.name === 'jobs.index'
      }
    },

    methods: {
      ...mapActions('job', ['updateJob']),
      ...mapMutations('job', [ADD_JOB]),

      /**
       * Handle the toggling of the job being public.
       *
       * @return Promise
       */
      toggleJobPublic () {
        return this.updateJob({ id: this.job.id, payload: { user_id: this.job.user_id, public: !this.job.public } }).then(response => {
          this[ADD_JOB](response.data)
          if (response.data.public) {
            notify.success('Job is now public.')
          } else {
            notify.success('Job is no longer public.')
          }
        }).catch(error => {
          if (error.response.status === 403) {
            notify.error('Unable to modify completed job.')
          } else {
            notify.error('Error modifying job.')
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// JobItem.vue?7bdbc84a